import React, { ChangeEvent } from "react";
import "./Pagination.scss";
import Input from "../Input/Input";
import Select from "../Select/Select";
import Button from "../Button/Button";
import Previous from "../Button/Previous";
import Rewind from "../Button/Rewind";
import Next from "../Button/Next";
import FastForward from "../Button/FastForward";

const AVAILABLE_PAGE_SIZES = [10, 25, 50, 100, 250, 500, 1000, 2500];
export { AVAILABLE_PAGE_SIZES };

interface PaginationProps {
	numResults: number;
	numPages: number;
	currentPage: number;
	pageSize: number;
	canPreviousPage: boolean;
	canNextPage: boolean;
	onFirstPage: Function;
	onPreviousPage: Function;
	onNextPage: Function;
	onLastPage: Function;
	onJumpToPage: Function;
	onChangePageSize: Function;
}

const Pagination = (props: PaginationProps) => {
	const {
		numResults,
		numPages,
		currentPage,
		pageSize,
		canPreviousPage,
		canNextPage,
		onFirstPage,
		onPreviousPage,
		onNextPage,
		onLastPage,
		onJumpToPage,
		onChangePageSize,
	} = props;

	const onGotoPageKeypress = (event: KeyboardEvent) => {
		if (event.key !== "Enter") return;

		const value = Number((event.target as HTMLInputElement).value);

		const pageIndex = value + 1;

		if (pageIndex < 0 || pageIndex >= numPages) return; // NB: Out of range

		onJumpToPage(value);
	};

	const onGotoPageChange = (event: ChangeEvent<HTMLInputElement>) => {
		onJumpToPage(Number(event.target.value) - 1);
	};

	return (
		<div className="pagination-container">
			<div>
				Showing <b>{Math.min(pageSize, numResults)}</b> of <b>~{numResults} results </b>
			</div>
			<div className="pagination-button-container">
				<Rewind disabled={!canPreviousPage} onClick={() => onFirstPage()} />
				<Previous disabled={!canPreviousPage} onClick={() => onPreviousPage()} />
				<Button variant="contained">{currentPage}</Button>
				<Next disabled={!canNextPage} onClick={() => onNextPage()} />
				<FastForward disabled={!canNextPage} onClick={() => onLastPage()} />
			</div>
			<div>
				<div className="page-counter">
					Page <b>{currentPage}</b> of <b>{numPages}</b>
				</div>
				{/* <div className="page-skip">
					<strong>Go to page</strong>
					<Input
						focus
						placeholder={currentPage.toString()}
						onKeyPress={onGotoPageKeypress}
						onChange={onGotoPageChange}
					/>
				</div> */}
				<div>
					<Select
						text={`Show ${pageSize}`}
						options={AVAILABLE_PAGE_SIZES.map((size) => {
							return { key: size, text: size, value: size };
						})}
						value={pageSize}
						onChange={(event, data) => onChangePageSize(data.value)}
					></Select>
				</div>
			</div>
		</div>
	);
};

export default Pagination;
